/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EmptyState } from '@backstage/core-components';

import { Button } from '@material-ui/core';

export const ForbiddenError = () => (
  <EmptyState
    missing="info"
    title="Unauthorized"
    description="You don't have the required permissions to perform this action. See README for more details."
    action={
      <Button
        color="primary"
        variant="contained"
        href="https://pagerduty.github.io/backstage-plugin-docs/getting-started/pagerduty/"
      >
        Read More
      </Button>
    }
  />
);
